import React, { FunctionComponent, useEffect, useState } from 'react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { useHistory } from 'react-router';
import { useEnvironment } from '../../contexts/EnvironmentContext';

interface Props {
  children: React.ReactNode;
}

export const AppInsightsProvider: FunctionComponent<Props> = ({ children }) => {
  const env = useEnvironment();
  const histroy = useHistory();

  const [ai, setAI] = useState<ReactPlugin | undefined>(undefined);

  useEffect(() => {
    if (env.isLoaded && !ai) {
      const reactPlugin = new ReactPlugin();
      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: env.settings.appInsightsKey,
          extensions: [reactPlugin],
          extensionConfig: {
            [reactPlugin.identifier]: { history: histroy },
          },
        },
      });
      appInsights.loadAppInsights();

      setAI(reactPlugin);
    }
  }, [env, ai, histroy]);

  if (!ai) {
    return <></>;
  }

  return (
    <AppInsightsContext.Provider value={ai}>
      {children}
    </AppInsightsContext.Provider>
  );
};
